import GlobalPeaceGap2019Screenshot from '../images/chartScreenshots/GlobalPeaceGap2019/globalPeaceGap2019.png'
import InfluentialPaintersScreenshot from '../images/chartScreenshots/InfluentialPainters2019/influentialPainters.png'
import JusticeAndPeace2019 from '../images/chartScreenshots/JusticeAndPeace2019/JusticeAndPeace2019.png'
import IEPLogo from '../images/chartScreenshots/GlobalPeaceGap2019/instituteForEconomicsAndPeace.png'
import BBLogo from '../icons/Logo/LogoText.png'
import JnPLogo from '../icons/Logo/PnJLogo.png'
import { JusticeAndPeaceDashboard } from '../../components/pages'

const mainContentData = [
    {
        title: 'Hear Their Voices',
        project: '#VizforSocialGood',
        organisation: 'Justice and Peace Netherlands',
        summary: "A tool that intents to help decision makers better understand and easier to cross-analyze the various challenges that local Human Rights Defenders and Legal Experts face in many countries around the globe.",
        dataSources: ["Justice and Peace Netherlands"],
        chartTypes: ["Horizontal Stacked Bar Chart", "Choropleth Map"],
        libraries: ["d3", "React", "React BeautifulDnD", "Ant Design", "Reactour"],
        chartImage: JusticeAndPeace2019,
        logo: JnPLogo,
        logoSize: .7,
        link: '/justice-and-peace',
        createdAt: 201908,
        date:  'August 2019',
        position: 'right',
        component: JusticeAndPeaceDashboard
    } ,
    {
        title: 'Global Peace Gap',
        project: '#dataforacause',
        organisation: 'Institute for Economics and Peace',
        summary: "Result of my participation in #dataforacause's 2019 June challenge initiated by Olga Tsubiks to visualise the dataset on Global Peace Index produced and provided by the Institute for Economics and Peace.",
        dataSources: ["Institute for Economics and Peace", "World Bank"],
        chartTypes: ["Beeswarm plot", "Barchart in tooltip", "Multiple line chart"],
        libraries: ["d3.js", "React", "Semantic UI React", "ReactTour"],
        chartImage: GlobalPeaceGap2019Screenshot,
        logo: IEPLogo,
        logoSize: 1,
        link: '/global-peace-gap',
        createdAt: 201906,
        date:  'June 2019',
        position: 'left',
        component: 'none'
    },
    {
        title: 'They Gave Color to Our History',
        project: '#boringbarchart',
        organisation: 'Boring Bar Chart',
        summary: "An own project providing you an overview you to discover the life and main chef d'ouvres of some of the most influential painters of our history starting from the 13th up until the 20th century.",
        dataSources: ["Kaggle - Best Artworks of All Time", "Wikipedia"],
        chartTypes: ["Gant Chart", "Horizontal Bar Chart"],
        libraries: ["d3.js", "React", "Semantic UI React", "React Carousel"],
        chartImage: InfluentialPaintersScreenshot,
        logo: BBLogo,
        logoSize: 1.5,
        link: '/influential-painters-of-our-history',
        createdAt: 201904,
        date:  'April 2019',
        position: 'right',
        component: 'none'
    }
]

export default mainContentData